import { Image as ImageIcon, MessageCircle } from 'lucide-react';
import type { CSSProperties } from 'react';
import { useCanvasStore } from './canvas-store';
import type { WorkspaceContext } from './canvas-types';

export interface SidebarChatMetadata {
  id: number;
  workspaceContext?: WorkspaceContext;
  hasCanvasImages?: boolean;
}

/** A chat can become creative after it was started in AI Agent. */
export function SidebarChatIcon({ task, style, size }: { task: SidebarChatMetadata; style?: CSSProperties; size?: number }) {
  const creative = useCanvasStore(state => {
    const loaded = state.projects[task.id];
    const hasLiveContext = loaded && (loaded.loadedAt || (state.activeProjectId === task.id && !loaded.loading));
    const context = hasLiveContext ? loaded.workspaceContext : task.workspaceContext;
    return context?.entryMode !== 'agent' || context.creativeActivated
      || task.workspaceContext?.creativeActivated === true
      || loaded?.workspaceContext.creativeActivated === true
      || task.hasCanvasImages === true || (loaded?.images.length ?? 0) > 0;
  });
  const Icon = creative ? ImageIcon : MessageCircle;
  return <Icon size={size} style={style} aria-hidden="true" data-chat-kind={creative ? 'canvas' : 'agent'}>
    <title>{creative ? 'Ad creation canvas' : 'AI Agent chat'}</title>
  </Icon>;
}
